import { CircularProgress } from '@material-ui/core';
import AkoBonusInfo from 'features/coupon/component/AkoBounsInfo';
import ChangeOddsPriority from 'features/coupon/component/changeOddsPriority';
import { BetType } from 'features/coupon/component/CouponPanel/interface';
import { AkoBonusData } from 'features/coupon/interface';
import { formatCouponPrice } from 'features/coupon/utility';
import { handleBalanceData } from 'features/customerPanel/store/cpPanel.action';
import { showLoginModal } from 'features/login/store/login.action';
import { OffersState } from 'features/offers/interface/store.interface';
import { fetchBonusesAndFreebets } from 'features/offers/store/offers.action';
import { PromoConditionsAccordion, usePromoConditionsStateTypes } from 'features/PromoConditions';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import BottomDrawer from 'shared/components/BottomDrawer';
import InfoDialogCard from 'shared/components/dialog/infoDialog';
import { addNotification } from 'shared/components/toast';
import { AKO, APP_URL, BONUS_BALANCE, MAIN_BALANCE, SYSTEM } from 'shared/constants/common';
import { FINANCIAL_THRESHOLDS } from 'shared/constants/financial-thresholds';
import { BalanceState, BETSType, PlaceBet, State } from 'shared/interface/index';
import { addBet } from 'shared/store/coupon.action';
import { createAction, getNumOfCombinations, isLoggedin, isMobile } from 'shared/util/utility';
import * as actionTypes from '../../../../shared/store/action-types';
import BetslipButton from '../BetslipButton/BetslipButton';
import { BetslipContent } from '../BetslipContent/BetslipContent';
import './styles.scss';

interface CouponPanelProps {
	text?: string;
	betStatics: any;
	deselectFreeBet: () => void;
	onClickPlaceBet: () => void;
	outcomes: PlaceBet[];
	loading: boolean;
	betMode: string;
	betLoading: boolean;
	approvedSlip: boolean;
	selectedFreeBet: string;
	selectedBalanceType: string;
	betType: number;
	freeBets: any[];
	changeNavigationView: () => void;
	blocks: PlaceBet[][];
	price: number;
	onChangeStackValue: (value: number) => void;
	awaitingWinningResp: boolean;
	handelSelectedFreeBet: (id: string, stack: number) => void;
	handleOddsChangeOption: (value: string) => void;
	isBetslipEmpty: boolean;
	selectedCombination: string;
	isCal: boolean;
	handleIsCal: (value: boolean) => void;
	promoConditionsState: usePromoConditionsStateTypes;
}

export const CouponPanel: React.FC<CouponPanelProps> = ({ ...props }) => {
	const couponPanelRef = useRef<HTMLDivElement | null>(null);
	const { t } = useTranslation();
	const history = useHistory();
	const [infoDialog, setInfoDialog] = useState(false);
	const [isCouponDrawer, setIsCouponDrawer] = useState(false);
	const awaitingWinningResp = useSelector<State, boolean>((state) => state.coupon.awaitingWinningResp);
	const offers = useSelector<State, OffersState>((state) => state.offers);
	const bets = useSelector<State, BETSType>((state) => state.coupon.bets);
	const totalOdds = props.outcomes.reduce((acc, item) => (item.selectedBet ? acc * item.outcomeOdds : acc), 1);
	const winningAmount = props?.betStatics?.newPossibleWinning?.totalWinning ?? 0;
	const freeBetStake = useSelector<State, number | null>((state) => state.coupon.bets.freeBetStack);
	const isFreeBetSelected = useSelector<State, any>((state) => state.coupon.bets.isFreeBetSelected);
	const dispatch = useDispatch();
	let isBetSelected = props.outcomes.some((item) => item.selectedBet);
	const course = isBetSelected ? totalOdds.toFixed(2) : Number(0).toFixed(2);
	const getAkoBonusDetails = (): AkoBonusData => ({
		bonusStepFrom: props.betStatics.newPossibleWinning?.totalBonus?.bonusStepFrom,
		currentBonusValue: props.betStatics.newPossibleWinning?.totalBonus?.currentBonusValue,
		futureBonusValue: props.betStatics.newPossibleWinning?.totalBonus?.futureBonusValue,
		minOutcomeOdds: props.betStatics.newPossibleWinning?.totalBonus?.minOutcomeOdds,
		bonusAmount: props.betStatics.newPossibleWinning?.bonus,
	});
	const [isOddsSelection, setIsOddsSelection] = useState(false);

	const isLiveSystemBetGroup = props.blocks.flat().find((item) => item.isLive);
	const isLiveBet = bets.outcomes.find((item) => item.isLive) || isLiveSystemBetGroup;
	const balanceData = useSelector<State, BalanceState>((state) => state.cpPanel.balanceData);
	const { selectedBalanceType, mainBalance } = balanceData;

	const depositBalanceBelowTwo = !!mainBalance && mainBalance < FINANCIAL_THRESHOLDS.MIN_BALANCE_FOR_PLACING_BET;
	const { currentBonusValue, futureBonusValue, bonusAmount } = getAkoBonusDetails();

	const { freebetsActive, bonusesQueued, bonusesActive } = offers;
	const isFreebetsActiveEmpty = freebetsActive.length === 0;
	const isBonusesQueuedEmpty = bonusesQueued.length === 0;
	const isBonusesActiveEmpty = bonusesActive.length === 0;

	const numOfSlipsWithGroups = props.outcomes.filter((item) => !item.banker).length + props.blocks.length;
	const numOfCombinations = getNumOfCombinations(numOfSlipsWithGroups, Number(props.selectedCombination));
	const systemStakeValue = bets.stake * numOfCombinations;
	const isSystemBetTab = props.betMode === SYSTEM;
	const isBonusBalance = props.selectedBalanceType === BONUS_BALANCE && !isFreeBetSelected;
	const isMainbalance = props.selectedBalanceType === selectedBalanceType && !isFreeBetSelected;
	const isAkoBonusDeactivated = (!currentBonusValue && !futureBonusValue) || !props.price;
	const isAkoBonusInfoUnavailable = isAkoBonusDeactivated || isBonusBalance || currentBonusValue < FINANCIAL_THRESHOLDS.MIN_AKO_BONUS_PERCENT;
	const stakeValue = isSystemBetTab ? systemStakeValue : freeBetStake ?? bets.stake;
	const showAmount = isBetSelected ? winningAmount : 0;
	const isBetmodAko = AKO;

	if (props.betMode === SYSTEM) {
		isBetSelected = true;
	}

	const handleBottomDrawer = () => {
		setIsCouponDrawer(!isCouponDrawer);
	};

	const getButtonText = () => {
		let buttonText = '';
		if (props.isBetslipEmpty) {
			buttonText = t('chooseEvent');
		}
		if (props.selectedFreeBet) {
			buttonText = t('playAndWinFreebet');
		}
		if (isLoggedin()) {
			buttonText = t('playAndWin');
		} else {
			buttonText = t('logAndWin');
		}
		return buttonText;
	};

	const [dynamicButton, setDynamicButton] = useState({
		name: t('depositShortened'),
		type: BetType.Deposit,
		amount: 0,
		dotNumber: freebetsActive.length + bonusesActive.length + bonusesQueued.length,
		onClick: () => (isLoggedin() ? handleBottomDrawer() : addNotification('info', t('betslipInfoToast'))),
	});

	const onClickPlaceBet = () => {
		if (isLoggedin()) {
			props.onClickPlaceBet();
		} else {
			if (!isMobile()) {
				dispatch(showLoginModal());
			} else {
				props.changeNavigationView();
			}
		}
	};

	const setCalculator = () => {
		if (isBetSelected && !props.selectedFreeBet) {
			props.handleIsCal(true);
		}
	};

	const placeBet = () => {
		if (!props.betLoading && !awaitingWinningResp && isBetSelected) {
			onClickPlaceBet();
			dispatch(createAction(actionTypes.ANALYTICS_CLEAR_BETS));
		}
	};

	const redirectToTodaysOffer = (step?: string) => {
		history.push(APP_URL.todaysOffer);
	};

	const renderAkoBonusInfoOnPlaceBet = () => {
		if (isAkoBonusInfoUnavailable) {
			return <></>;
		}

		return <AkoBonusInfo bonusAmount={bonusAmount} currentBonusValue={currentBonusValue} />;
	};

	function formatStakeValue(stakeValue: number | string): string {
		return t('Common_currency', { val: stakeValue });
	}

	const handleCourseClick = () => {
		if (!isLiveBet) {
			setInfoDialog(true);
		} else {
			setIsOddsSelection(true);
			handleBottomDrawer();
		}
	};

	const handleSetDynamicButton = (isFreeBetSelected: boolean) => {
		if (isFreeBetSelected) {
			setDynamicButton({
				...dynamicButton,
				name: t('freebet'),
				type: BetType.Freebet,
				amount: stakeValue,
				dotNumber: freebetsActive.length + bonusesActive.length + bonusesQueued.length,
			});
		} else if (selectedBalanceType === MAIN_BALANCE) {
			setDynamicButton({
				...dynamicButton,
				name: t('depositShortened'),
				type: BetType.Deposit,
				amount: mainBalance || 0,
				dotNumber: freebetsActive.length + bonusesActive.length + bonusesQueued.length,
			});
		} else if (selectedBalanceType === BONUS_BALANCE) {
			// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
			const bonusAmount = bonusesActive && bonusesActive.length > 0 ? bonusesActive[0]!.balanceValue?.amount || 0 : 0;

			setDynamicButton({
				...dynamicButton,
				name: t('bonusShortened'),
				type: BetType.Bonus,
				amount: bonusAmount,
				dotNumber: freebetsActive.length + bonusesActive.length + bonusesQueued.length,
			});
			if (stakeValue > bonusAmount) {
				dispatch(createAction(actionTypes.UPDATE_BETS_STAKE, { betsStake: bonusAmount }));
			}
		}
	};

	useEffect(() => {
		handleSetDynamicButton(isFreeBetSelected);
	}, [isLoggedin(), isFreeBetSelected, selectedBalanceType, props.selectedFreeBet, freebetsActive, bonusesActive, bonusesQueued, mainBalance]);

	useEffect(() => {
		if (props.isBetslipEmpty) {
			props.handelSelectedFreeBet('', 0);
		}
	}, [props.isBetslipEmpty]);

	useEffect(() => {
		if (!couponPanelRef.current) return;

		const updateHeight = () => {
			const height = couponPanelRef.current?.getBoundingClientRect().height ?? 0;
			props.promoConditionsState.setPromoAccordionWrapperHeight(height);
		};

		const observer = new ResizeObserver(updateHeight);
		observer.observe(couponPanelRef.current);

		updateHeight();

		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		dispatch(fetchBonusesAndFreebets());
	}, []);

	useEffect(() => {
		const activeBonus = bonusesActive[0];
		const isBonusUnlocked = activeBonus?.bonusUnlocked || (!activeBonus?.bonusUnlocked && !activeBonus?.unlockConditions);

		if (selectedBalanceType === BONUS_BALANCE && !isBonusUnlocked) {
			dispatch(
				handleBalanceData({
					...balanceData,
					selectedBalanceType: MAIN_BALANCE,
				}),
			);
			dispatch(addBet({ ...bets, bonusBet: false }));
		}
	}, [selectedBalanceType, bonusesActive, dispatch, balanceData, bets, handleBottomDrawer]);

	return (
		<>
			{isCouponDrawer && (
				<BottomDrawer
					usePortal={isMobile()}
					isBottomDrawer={isCouponDrawer}
					handleBottomDrawer={handleBottomDrawer}
					drawerBackground="primary"
					className="couponPanel__bottomDrawer"
					cyCloseModalRef="betslip-close-drawer"
				>
					{isOddsSelection ? (
						<ChangeOddsPriority handleOddsChangeOption={props.handleOddsChangeOption} />
					) : (
						<BetslipContent
							handleBottomDrawer={handleBottomDrawer}
							isSystemBetTab={isSystemBetTab}
							deselectFreeBet={props.deselectFreeBet}
							bets={bets}
							freebetsActive={freebetsActive}
							bonusesActive={bonusesActive}
							bonusesQueued={bonusesQueued}
							isFreebetsActiveEmpty={isFreebetsActiveEmpty}
							isBonusesQueuedEmpty={isBonusesQueuedEmpty}
							isBonusesActiveEmpty={isBonusesActiveEmpty}
							isFreebet={isFreeBetSelected}
							freeBets={props.freeBets}
							handelSelectedFreeBet={props.handelSelectedFreeBet}
							selectedFreeBet={props.selectedFreeBet}
						/>
					)}
				</BottomDrawer>
			)}

			<div className="couponPanel" ref={couponPanelRef}>
				<PromoConditionsAccordion
					promoConditionsState={props.promoConditionsState}
					bets={bets}
					freebetsActive={freebetsActive}
					bonusesActive={bonusesActive}
					course={course}
				/>
				<div>
					<div className={'gap-2 mb-4 flex justify-between items-center flex-1'}>
						{isLoggedin() && (
							<BetslipButton
								depositBalanceBelowTwo={depositBalanceBelowTwo}
								key={`couponDynamicButton-dynamicButton`}
								{...dynamicButton}
							/>
						)}
						<BetslipButton name={t('totalCourse')} amount={course} onClick={() => handleCourseClick()} />
						<BetslipButton
							name={t('currentStack')}
							isFreeBetSelected={isFreeBetSelected}
							amount={formatStakeValue(stakeValue)}
							onClick={() => setCalculator()}
						/>
					</div>
					{isBetmodAko && isMainbalance && renderAkoBonusInfoOnPlaceBet()}
					<button
						className="couponPanel__betBtn"
						onClick={props.isBetslipEmpty ? () => redirectToTodaysOffer() : () => placeBet()}
						data-cy="place-bet"
						data-cy-is-loading={props.betLoading || props.awaitingWinningResp ? true : false}
					>
						{props.betLoading || props.awaitingWinningResp ? (
							<CircularProgress color="primary" className="PlaceBet__loader" />
						) : (
							<>
								<span className="couponPanel__betBtn__text">{getButtonText()}</span>
								<span className="couponPanel__betBtn__amount">
									{props.isBetslipEmpty ? t('placeBet') : `${formatCouponPrice(showAmount)} ${t('currency')}`}
								</span>
							</>
						)}
					</button>
					<div className="couponPanel__factor">
						{t('factor')} {props.betStatics.taxFactor}
					</div>
				</div>
			</div>

			{infoDialog && <InfoDialogCard subTitle={t('courseInfoDialogDescription')} iconTitle="" onClose={() => setInfoDialog(false)} />}
		</>
	);
};
